import { cn } from '@/lib/utils';

export interface AppLogoProps {
  /**
   * 'full': Wide horizontal logo: icon, divider and "blue b" wordmark (SVG, wordmark as paths)
   * 'icon': Crisp circular mark alone (ideal for collapsed sidebar or small buttons)
   * 'mark': Round mark without the divider bar (landing page), recoloured for light backgrounds
   */
  variant?: 'full' | 'icon' | 'mark';
  alt?: string;
  className?: string;
}

export function AppLogo({
  variant = 'full',
  alt = 'BlueB',
  className,
}: AppLogoProps) {
  const darkSrc = { full: '/blueb-logo-dark.svg', icon: '/blueb-icon-dark.webp', mark: '/blueb-mark.png' }[variant];
  const lightSrc = { full: '/blueb-logo-light.svg', icon: '/blueb-icon-white.webp', mark: '/blueb-mark-light.png' }[variant];

  return (
    <>
      <img
        src={darkSrc}
        alt={alt}
        className={cn('logo-on-dark object-contain select-none', className)}
      />
      <img
        src={lightSrc}
        alt={alt}
        className={cn('logo-on-light object-contain select-none', className)}
      />
    </>
  );
}
